<template>
  <section class="section">
    <div class="container">
      <h1 class="title has-text-primary">
        <strong>
          Playback
        </strong>
      </h1>

      <div class="is-medium" v-if="this.playbacks.length > 0">
        <table class="table is-fullwidth has-open-spacing">
          <tbody>

            <tr v-for="playback in playbacks">
              <td>
                <playback-details :playback="playback"></playback-details>
              </td>
            </tr>

          </tbody>
        </table>
      </div>

      <div v-else>
        No items to display
      </div>

    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import PlaybackDetails from '@/components/PlaybackDetails.vue'

export default {
  name: 'playback',
  components: { PlaybackDetails },
  computed: {
    ...mapGetters(['chapter'])
  },
  data () {
    return {
      playbacks: []
    }
  },
  created: function () {
    this.playbacks = require('@/assets/data/' + this.chapter.shortname + '/playback.yml')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Playback.vue?0478ea6b